<div class="nav-container">
  <mat-toolbar color="primary">
    <mat-toolbar-row>
      <img alt="Lorentz" class="lorentz-logo" src="/assets/LOGO_LORENTZ_WHITE.svg">
      <nav class="nav-content" *appIsAuthenticated>
        <a mat-button matTooltip="open the product data" routerLink="/data" routerLinkActive="active">
          <span>Product data</span>
        </a>
        <a mat-button matTooltip="open the pump simulation" (click)="cleanData()" routerLink="/simulations"
          routerLinkActive="active">
          <span>Pump simulation</span>
        </a>
        @if ((isAdmin$ | async)) {
          <a mat-button matTooltip="open data upload/download" routerLink="/upload"
            routerLinkActive="active">
            <span>Data upload/download</span>
          </a>
          <a mat-button matTooltip="manage number ranges" routerLink="/number-ranges"
            routerLinkActive="active">
            <span>Number ranges</span>
          </a>
        }
      </nav>
      <div class="flex-spacer"></div>
      <div>
        @if ((isNotAuthenticated$ | async)) {
          <button mat-button routerLink="/login">Login</button>
        }
        @if ((isAuthenticated$ | async)) {
          <button mat-button (click)="logout()">Logout</button>
        }
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
